const colorPrimary = '#7388d9';
export const Theme = () => ({
  colorPrimary,
  colorLink: colorPrimary,
  colorLinkHover: colorPrimary,
  colorLinkActive: colorPrimary,
  fontFamily: '"Poppins", sans-serif',
  colorInfo: colorPrimary,
});
